// extracted by mini-css-extract-plugin
export default {"disabled":"styles_disabled__YKWvc"};